// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".light-theme .map-world .toggle-traffic {\n  background-color: #FFF;\n  border-radius: 2px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n  cursor: pointer;\n  text-align: center;\n  margin: 10px;\n  min-width: 85px;\n}\n.light-theme .map-world .toggle-traffic .text {\n  color: #565656;\n  font-family: Karla, Roboto, Arial, sans-serif;\n  font-size: 11px;\n  line-height: 29px;\n  padding: 0 8px;\n}\n.light-theme .map-world .toggle-traffic .text:hover {\n  color: #000;\n  background-color: #ebebeb;\n}\n.light-theme .map-world .toggle-traffic .text.active {\n  background-color: #2B3990;\n  color: #FFF;\n  font-weight: 700;\n}\n.dark-theme .map-world .toggle-traffic {\n  background-color: #FFF;\n  border-radius: 2px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n  cursor: pointer;\n  text-align: center;\n  margin: 10px;\n  min-width: 85px;\n}\n.dark-theme .map-world .toggle-traffic .text {\n  color: #565656;\n  font-family: Karla, Roboto, Arial, sans-serif;\n  font-size: 11px;\n  line-height: 29px;\n  padding: 0 8px;\n}\n.dark-theme .map-world .toggle-traffic .text:hover {\n  color: #000;\n  background-color: #ebebeb;\n}\n.dark-theme .map-world .toggle-traffic .text.active {\n  background-color: #8400FF;\n  color: #FFF;\n  font-weight: 700;\n}", ""]);
// Exports
exports.locals = {
	"blacker": "#262626",
	"black": "#333333",
	"white": "#FFF",
	"red": "#DC3545",
	"orange": "#EB8D20",
	"yellow": "#F7D601",
	"green": "#14AF1B",
	"legacy-blue": "#A5D8FF",
	"bay-blue": "#2A3D92",
	"bay-blue-dark": "#2B3990",
	"bay-blue-darker": "#222E73",
	"neon-purple": "#8400FF",
	"navbar-height-no-unit": "56",
	"top-toolbar-height-no-unit": "56",
	"md-min": "768"
};
module.exports = exports;
